/**
 * Support Management
 * Gestão de tickets de suporte
 */
import { HeadphonesIcon, MessageSquare, Clock, CheckCircle2 } from 'lucide-react'

const tickets = [
  { id: '#1234', company: 'ContruBem S.A.', subject: 'Problema com detecção de EPI', priority: 'high', status: 'open', createdAt: '2h atrás' },
  { id: '#1233', company: 'TeleNord', subject: 'Dúvida sobre relatórios', priority: 'medium', status: 'open', createdAt: '4h atrás' },
  { id: '#1232', company: 'Hospital Santa Cruz', subject: 'Integração com sistema RH', priority: 'low', status: 'pending', createdAt: '1 dia atrás' },
]

export default function Support() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-white">Suporte</h1>
        <p className="text-slate-400">Gestão de tickets e atendimento</p>
      </div>
      
      {/* Stats */}
      <div className="grid grid-cols-4 gap-4">
        <div className="admin-stat">
          <MessageSquare className="w-8 h-8 text-violet-400 mb-3" />
          <p className="text-2xl font-bold text-white">12</p>
          <p className="text-sm text-slate-400">Tickets Abertos</p>
        </div>
        <div className="admin-stat">
          <Clock className="w-8 h-8 text-amber-400 mb-3" />
          <p className="text-2xl font-bold text-white">2.4h</p>
          <p className="text-sm text-slate-400">Tempo Médio Resposta</p>
        </div>
        <div className="admin-stat">
          <CheckCircle2 className="w-8 h-8 text-emerald-400 mb-3" />
          <p className="text-2xl font-bold text-white">94%</p>
          <p className="text-sm text-slate-400">Taxa Resolução</p>
        </div>
        <div className="admin-stat">
          <HeadphonesIcon className="w-8 h-8 text-cyan-400 mb-3" />
          <p className="text-2xl font-bold text-white">4.8</p>
          <p className="text-sm text-slate-400">Satisfação (NPS)</p>
        </div>
      </div>
      
      {/* Tickets List */}
      <div className="admin-card">
        <h2 className="text-lg font-semibold text-white mb-4">Tickets Recentes</h2>
        <div className="space-y-3">
          {tickets.map((ticket) => (
            <div key={ticket.id} className="p-4 rounded-xl bg-slate-800/30 border border-slate-700/50 hover:border-violet-500/30 transition-colors">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center gap-3 mb-1">
                    <span className="text-sm font-mono text-slate-500">{ticket.id}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                      ticket.priority === 'high' ? 'bg-rose-500/10 text-rose-400' :
                      ticket.priority === 'medium' ? 'bg-amber-500/10 text-amber-400' :
                      'bg-slate-500/10 text-slate-400'
                    }`}>
                      {ticket.priority}
                    </span>
                  </div>
                  <p className="font-medium text-white">{ticket.subject}</p>
                  <p className="text-sm text-slate-500">{ticket.company} • {ticket.createdAt}</p>
                </div>
                <button className="btn-secondary text-sm">Ver Ticket</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

